import { Box } from '@shared/components';
import { useState, type KeyboardEvent } from 'react';

import NavMenuItem, { type NavMenuItemProps } from './nav-menu-item';

type NestedMenuItemProps = Pick<
  NavMenuItemProps,
  'label' | 'icon' | 'link' | 'subMenu' | 'minified'
>;

function NestedMenuItem(props: Readonly<NestedMenuItemProps>) {
  const { minified: shouldMinified, ...menu } = props;
  const [isOpen, setIsOpen] = useState(false);
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      setIsOpen(!isOpen);
    }
  };

  return (
    <>
      <Box onKeyDown={handleKeyDown} onClick={() => setIsOpen(!isOpen)}>
        <NavMenuItem {...menu} open={isOpen} minified={shouldMinified} />
      </Box>
      {menu.subMenu?.map((subMenuItem) => (
        <NavMenuItem
          key={subMenuItem.label as string}
          {...subMenuItem}
          minified={shouldMinified || isOpen}
          collapsible
        />
      ))}
    </>
  );
}

export type { NestedMenuItemProps };
export default NestedMenuItem;
